import React from 'react'
import { AiOutlineSearch } from 'react-icons/ai'
import TextField from '@mui/material/TextField'

import s from './styles.module.scss'

const SearchQuestion = ({ input, handleChange }) => {
  return (
    <div className={s.searchContainer}>
      <TextField
        id="search"
        autoComplete="off"
        label="Buscador de preguntas frecuentes"
        variant="standard"
        fullWidth={true}
        type="text"
        value={input}
        onChange={handleChange}
        className={s.searchInput}
        InputProps={{
          endAdornment: <AiOutlineSearch />,
        }}
      />
    </div>
  )
}

export default SearchQuestion
